export default "__VITE_ASSET__CPiEnzju__"